module.exports = __webpack_public_path__ + "static/media/toggleOff.b7da23c7.svg";